@if (prefixControl && phoneControl) {
  <div class="phone-input-container">
    <app-ui-input
      [label]="'mobilePrefix' | translate"
      [control]="prefixControl"
      [required]="true"
    ></app-ui-input>
    <app-ui-input
      [label]="'phoneNumber' | translate"
      [control]="phoneControl"
      [required]="true"
    ></app-ui-input>
  </div>
  @if (phoneError) {
    <span class="mat-mdc-form-field-error pl-05">{{ phoneError | translate }}</span>
  }
}
